module.exports = __webpack_public_path__ + "static/appInto04-c502981df490b3f503c523bffea9bb7d.png";